import { Badge } from "@/components/ui/badge/Badge";
import type { RatingLevel } from "@/services/api/guardiansv2/types";
import { RATING_BADGE_COLOR, RATING_LABELS } from "./constants";

export interface RatingBadgeProps {
  rating: RatingLevel | null | undefined;
  /** Show spinner when audit is in-flight. */
  pending?: boolean;
  size?: "sm" | "md";
  showLabel?: boolean;
  className?: string;
}

/**
 * RAG rating pill shared by Guardians audits and cross-app annotations.
 */
export function RatingBadge({
  rating,
  pending = false,
  size = "sm",
  showLabel = true,
  className = "",
}: RatingBadgeProps) {
  if (pending || !rating) {
    return (
      <span
        className={`inline-flex items-center rounded-full bg-slate-700/60 px-2 py-0.5 text-[10px] uppercase tracking-wide text-slate-400 ${className}`}
        data-testid="rating-badge-pending"
      >
        —
      </span>
    );
  }

  return (
    <Badge
      color={RATING_BADGE_COLOR[rating]}
      className={`${size === "sm" ? "text-[10px]" : "text-xs"} uppercase ${className}`}
      data-testid={`rating-badge-${rating}`}
    >
      {showLabel ? RATING_LABELS[rating] : null}
    </Badge>
  );
}
